import { Box, Button, Center, Spinner, Text } from '@chakra-ui/react'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useGetLeadershipValueScoresQuery } from '~/app/services/api'
import { useLocale } from '../../../hooks/useLocale'
import HupoPerspectivesResult from '../HupoPerspectivesResult'
import PeerManagement from '../PeerManagement'

export const StartOfJourney = () => {
  const { t } = useLocale()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const tab = params.get('tab')
  const [selectedIndex, setSelectedIndex] = useState(tab === 'results' ? 1 : 0)

  const {
    data: leadershipValueScores,
    isLoading,
    error,
  } = useGetLeadershipValueScoresQuery({})

  if (isLoading)
    return (
      <Center>
        <Spinner size="2xl" />
      </Center>
    )
  if (error)
    return (
      <Center>
        <Text>{t('error_fetching_data')}</Text>
      </Center>
    )

  if (
    leadershipValueScores?.scores &&
    Object.keys(leadershipValueScores.scores.self).length === 0
  ) {
    return (
      <Center>
        <Box textAlign="center" py={4} px={6}>
          <Text>{t('complete_hupo_perspectives_before_viewing_insights')}</Text>
          <Button
            mt={4}
            mb={6}
            colorScheme="primary"
            onClick={() => navigate('/assessment')}
          >
            {t('complete_hupo_perspectives')}
          </Button>
        </Box>
      </Center>
    )
  }

  const handleTabChange = (index: number) => {
    setSelectedIndex(index)
    if (index === 1) {
      navigate('./?tab=results')
    } else {
      navigate('./?tab=respondent-management')
    }
  }

  return (
    <div className="space-y-4">
      <TabGroup selectedIndex={selectedIndex} onChange={handleTabChange}>
        <TabList className="flex space-x-4 border-b border-gray-200">
          <Tab
            className={({ selected }) =>
              `border-b-2 px-4 py-2 text-sm font-medium transition-all
              ${
                selected
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`
            }
          >
            {t('peer_response_management')}
          </Tab>
          <Tab
            className={({ selected }) =>
              `border-b-2 px-4 py-2 text-sm font-medium transition-all
              ${
                selected
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`
            }
          >
            {t('results')}
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <PeerManagement leadershipValueScores={leadershipValueScores} />
          </TabPanel>
          <TabPanel>
            <HupoPerspectivesResult
              leadershipValueScores={leadershipValueScores}
            />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  )
}
